"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));
var Styled = _interopRequireWildcard(require("./styles/IconSound.style"));
var _ruleSet = require("../../ruleSet");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var IconSound = function IconSound(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
    _ref$isResponsive = _ref.isResponsive,
    isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    state = _ref.state,
    numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m139.9 171.6-50.3-42.8c-4.5-3.5-7.9-4.5-12.8-4.5H51.1c-8.3 0-15-6.7-15-15v-26c0-8.3 6.7-15 15-15h25.7c4.8 0 8.3-1 12.8-4.5l50.3-43.1v150.9z",
    fill: "none",
    vectorEffect: "non-scaling-stroke"
  })), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};
IconSound.displayName = "IconSound";
var _default = IconSound;
exports["default"] = _default;